import { Sun, ShieldCheck, Sprout } from "lucide-react";

const items = [
  {
    n: "01",
    icon: Sun,
    title: "Normal bone health",
    text: "Vitamin D contributes to the maintenance of normal bones — a foundation often overlooked in modern routines.",
  },
  {
    n: "02",
    icon: ShieldCheck,
    title: "Normal immune function",
    text: "Plays a role in the normal function of the immune system, supporting your body's everyday resilience.",
  },
  {
    n: "03",
    icon: Sprout,
    title: "Overall wellbeing",
    text: "Helps maintain a sense of overall wellbeing as part of a balanced lifestyle and varied diet.",
  },
];

export const Benefits = () => {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="bg-[#FDFBF7] py-24 md:py-32 border-t border-[#E5E8E3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="flex items-center gap-3 mb-6">
            <span className="ah-hairline" />
            <span className="text-xs uppercase tracking-[0.28em] font-semibold text-[#1A362D]">
              Why Vitamin D3 Matters
            </span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A362D] leading-[1.08] tracking-tight font-medium">
            A small nutrient with a <em className="italic text-[#C29B62] font-normal">quiet</em> role in everyday life.
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#4A5D56] font-light max-w-2xl leading-relaxed">
            Vitamin D plays an important role in several physiological functions. Here's what it contributes to as part
            of a balanced nutritional intake.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <article
                key={it.n}
                data-testid={`benefit-card-${idx + 1}`}
                className="group relative bg-[#F3F5F1] p-10 md:p-12 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-10">
                  <span className="font-serif-display text-[#C29B62] text-3xl md:text-4xl">{it.n}</span>
                  <Icon className="w-6 h-6 text-[#1A362D]/70" strokeWidth={1.25} />
                </div>
                <h3 className="font-serif-display text-2xl md:text-[28px] text-[#1A362D] leading-tight font-medium">
                  {it.title}
                </h3>
                <p className="mt-4 text-[15px] md:text-base text-[#4A5D56] font-light leading-relaxed">{it.text}</p>
                <div className="mt-10 h-px w-10 bg-[#C29B62] transition-all duration-500 group-hover:w-20" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
